import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { GoogleLogin } from "@react-oauth/google";
import { appleAuthHelpers } from "react-apple-signin-auth";
// import AppleSignin from 'react-apple-signin-auth';
import fullbot from '../../assets/common/resources/fullbot.png';

import { Typography, Box, Stack, Button, Checkbox } from "@mui/material";
import { Images } from "../../assets/common";
import ApiService from "./../../services/api-service";
import { UserContext } from "../../context/userContext";
import {
  GOOGLE_CLIENT_ID,
  APPLE_CLIENT_ID,
  APPLE_REDIRECT_URI,
} from "../../constants/api";
import DoneIcon from "@mui/icons-material/Done";
import Loader from "../../components/Loader";
import notifier from "./../../components/Notifier";
import cookieStorage from "../../services/cookie-storage";
import {
  getUserDetail,
  isLoggedInUser,
  updateUserDetail,
  getErrorString,
  isMobile, getUserId,
} from "../../constants/function";
import "./index.scss";
import { SocketContext } from "../../context/socket";
import * as io from "socket.io-client";
import { SERVER_URL } from "../../constants/api";
import { Formik } from "formik";
// import * as yup from "yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import common_en from "../../translations/en/common.json";
import { setLanguage } from "../../action/language";
import { useDispatch, useSelector } from "react-redux";
import DropDown from "../../components/DropDown";
import { v4 as uuidv4 } from "uuid";

// Debug logs removed for production

export default function Signup() {
  const [languageData, setLanguageData] = useState(null);
  const [lang, setLang] = useState(null);
  const dispatch = useDispatch();
  const { t } = useTranslation("common");
  const userData = getUserDetail();
  
  // ULTIMATE SAFEGUARD: If user has complete profile, redirect immediately
  React.useEffect(() => {
    if (userData && userData.birthYear && isLoggedInUser()) {
      console.log('SIGNUP SAFEGUARD: User already has birthYear, forcing redirect to home');
      window.location.href = '/app/home';
    }
  }, []);
  const { Socket, setSocket } = useContext(SocketContext);
  const label = { inputProps: { "aria-label": "Accept privacy policy" } };
  const [checked, setChecked] = useState(false);
  const [isWhitelisted, setisWhitelisted] = React.useState(null);
  const [gender, setGender] = React.useState(null);
  const [age, setAge] = React.useState(null);
  const [amount, setAmount] = React.useState("");
  const formRef = React.useRef();
  const [loggedin, setLoggedin] = React.useState(false);
  const history = useHistory();
  const params = new URLSearchParams(history.location.search);

  const returnUrl = params.get("returnUrl");
  const nftId = params.get("nftId");
  const [loading, setLoading] = useState();
  const { setUser } = useContext(UserContext);
  let userDetail = getUserDetail();
  const schema = yup.object().shape({
    birthYear: yup.string(),
  });

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const channel = urlParams.get('livestream') || false;
  if (!!channel && channel.trim() !== '') {
    localStorage.setItem('dynamicLink', channel);
  }

  const handleGoogleSuccess = async (credentialResponse) => {
    setLoading(true);
    try {
      // credentialResponse.credential is the ID token
      ApiService.googleSignInWithToken({
        idToken: credentialResponse.credential
      })
      .then(async (response) => {
        setUser(response["result"]);
        localStorage.setItem("userData", JSON.stringify(response.result));
        cookieStorage.createCookie( "userId", getUserId() );
        // dtMD('userId', getUserId());

        localStorage.setItem("token", response.result["token"]);
        localStorage.setItem("sessionId", uuidv4());
        localStorage.setItem(
          "streamingBalance",
          response.result["userData"]["streamingBalance"]
        );

        cookieStorage.createCookie(
          "Authorization",
          response.result["token"],
          1
        );
        cookieStorage.createCookie(
          "SikiAccounts",
          JSON.stringify(response.result["accounts"]),
          1
        );
        cookieStorage.createCookie(
          "swapObject",
          JSON.stringify(response.result["swapObject"]),
          1
        );
        await getUserProfile(response.result["token"]);
        console.log("Google login complete");
        // Don't set loading to false - getUserProfile handles navigation
      })
      .catch((err) => {
        console.error("Google login API error:", err);
        console.error("Error details:", {
          message: err.message,
          response: err.response,
          status: err.response?.status,
          data: err.response?.data
        });
        setLoading(false);
        
        // More specific error messages
        if (err.response?.status === 503) {
          notifier.error('Server is temporarily unavailable. Please try again in a few moments.');
        } else if (err.response?.status === 500) {
          notifier.error('Server error. Please try again later.');
        } else if (err.message?.includes('Network')) {
          notifier.error('Network error. Please check your connection.');
        } else {
          notifier.error('Login failed. Please try again.');
        }
      });
    } catch (error) {
      console.error('Google login error:', error);
      notifier.error('Google login failed');
      setLoading(false);
    }
  };

  const appleLogin = async () => {
    const appleResponse = await appleAuthHelpers.signIn({
      authOptions: {
        clientId: APPLE_CLIENT_ID,
        scope: "email name",
        redirectURI: APPLE_REDIRECT_URI,
        usePopup: true,
      },
      onSuccess: (res) => {
        setLoading(true);
        var payLoad;
        if (res["user"]) {
          //console.log("payload1");
          payLoad = {
            idToken: res["authorization"]["id_token"],
            firstName: res["user"]["name"]["firstName"],
            lastName: res["user"]["name"]["lastName"],
          };
        } else {
          //console.log("payload2");
          payLoad = {
            idToken: res["authorization"]["id_token"],
          };
        }
        ApiService.appleSignInWithToken(payLoad)
          .then(async (response) => {
            setUser(response["result"]);
            localStorage.setItem("userData", JSON.stringify(response.result));
            cookieStorage.createCookie( "userId", getUserId() );
            // dtMD('userId', getUserId());

            localStorage.setItem("token", response.result["token"]);
            localStorage.setItem(
              "streamingBalance",
              response.result["userData"]["streamingBalance"]
            );

            cookieStorage.createCookie(
              "Authorization",
              response.result["token"],
              1
            );
            cookieStorage.createCookie(
              "SikiAccounts",
              JSON.stringify(response.result["accounts"]),
              1
            );
            cookieStorage.createCookie(
              "swapObject",
              JSON.stringify(response.result["swapObject"]),
              1
            );
            await getUserProfile(response.result["token"]);
            // Don't set loading to false - getUserProfile handles navigation
          })
          .catch((err) => {
            setLoading(false);
            //console.log(err);
          });
      },
      onError: (error) => console.error(error),
    });
  };

  const getUserProfile = async (token) => {
    console.log("getUserProfile called with token:", token);
    
    // Add timeout to prevent infinite loading
    const timeoutId = setTimeout(() => {
      console.error("getUserProfile timeout - redirecting to login");
      setLoading(false);
      logoutAndReturnToLogin();
    }, 15000); // 15 second timeout
    
    try {
      const response = await ApiService.USER_PROFILE(token);
      clearTimeout(timeoutId); // Clear timeout on success
      console.log("USER_PROFILE response:", response);
      
      // Store userData consistently
      const existingData = JSON.parse(localStorage.getItem("userData") || "{}");
      const updatedData = {
        ...existingData,
        userData: response.result
      };
      localStorage.setItem("userData", JSON.stringify(updatedData));
      setisWhitelisted(response["result"]["isWhiteListed"]);
      localStorage.setItem(
        "isWhiteListed",
        response["result"]["isWhiteListed"]
      );
      getI18nData(token);

      setTimeout(() => {
        if (
          !response["result"]["gender"] ||
          response["result"]["gender"] === "" ||
          !response["result"]["birthYear"]
        ) {
          setLoggedin(true);
          setLoading(false); // Fix: Stop loading when showing profile form
          setGender(
            response?.result?.gender === "MALE"
              ? 0
              : response?.result?.gender === "FEMALE"
              ? 1
              : response?.result?.gender === "OTHER"
              ? 2
              : null
          );
        } else if (response["result"]["isWhiteListed"]) {
          // Don't set loading to false - keep it true during navigation
          if (
            returnUrl &&
            (returnUrl.includes("/app/LiveVideoStreaming/") ||
              returnUrl.includes("/app/ArtistProfile/") ||
              returnUrl.includes("/app/Music/") ||
              returnUrl.includes("/app/SongDetails/"))
          ) {
            history.push(returnUrl);
          } else if (returnUrl && returnUrl === "/app/Wallet/addBalance") {
            history.push(returnUrl);
          } else {
            console.log("Redirecting to /app/Home");
            history.push("/app/Home");
          }
        } else if (response["result"]["isWhiteListed"] === false) {
          // Don't set loading to false - keep it true during navigation
          console.log("User not whitelisted, redirecting to /WaitList");
          history.push("/WaitList");
        } else {
          // Don't set loading to false - keep it true during navigation
          console.log("Default redirect to /WaitList");
          history.push("/WaitList");
        }
      }, 0);
      return;
    } catch (error) {
      console.error("getUserProfile error:", error);
      clearTimeout(timeoutId); // Clear timeout on error
      setLoading(false);
      // If profile fetch fails, logout and return to login
      logoutAndReturnToLogin();
      return null;
    }
  };

  const updateProfile = async (values) => {
    try {
      getI18nData(lang);
      setLoading(true);
      let userDetail = getUserDetail();
      const formData = new FormData();

      formData.append(
        "gender",
        gender === 0 ? "MALE" : gender === 1 ? "FEMALE" : "OTHER"
      );
      formData.append("age", age === 0 ? "number" : "null");
      for (const key in formRef.current.values) {
        formData.append(key, formRef.current.values[key]);
      }

      const response = await ApiService.UPDATE_USER(formData);

      userDetail = response["result"];
      updateUserDetail(userDetail);
      setLoading(false);
      // if (isWhitelisted)
      getI18nData(lang);
      history.push("/app/Home");
      // else if (isWhitelisted === false) {
      //   history.push("/WaitList");
      // }
    } catch (error) {
      setLoading(false);

      notifier.error(getErrorString(error));
    }
  };

  const logoutAndReturnToLogin = () => {
    // Clear all authentication data
    localStorage.clear();
    cookieStorage.deleteCookie("Authorization");
    cookieStorage.deleteCookie("userId");
    cookieStorage.deleteCookie("SikiAccounts");
    cookieStorage.deleteCookie("swapObject");
    cookieStorage.deleteCookie("isWhiteListed");
    cookieStorage.deleteCookie("language");
    
    // Force a full page reload to reset all state
    window.location.href = "/";
  };

  React.useEffect(() => {
    const bYear = userData?.birthYear;
    if (
      !isLoggedInUser() &&
      returnUrl &&
      (returnUrl.includes("/app/LiveVideoStreaming/") ||
        returnUrl.includes("/app/ArtistProfile/") ||
        returnUrl.includes("/app/Music/") ||
        returnUrl.includes("/app/SongDetails/"))
    ) {
    } else if (isLoggedInUser() && bYear) {
      localStorage.setItem("sessionId", uuidv4());
      if (
        returnUrl &&
        (returnUrl.includes("/app/LiveVideoStreaming/") ||
          returnUrl.includes("/app/ArtistProfile/") ||
          returnUrl.includes("/app/Music/") ||
          returnUrl.includes("/app/SongDetails/"))
      ) {
        if (nftId) {
          const path = returnUrl + "&nftId=" + nftId;
          history.push(path);
        } else history.push(nftId ? `${returnUrl}&nftId=${nftId}` : returnUrl);
      } else if (returnUrl && returnUrl === "/app/Wallet/addBalance")
        history.push(returnUrl);
      else history.push("/app/Home");
    } else if (isLoggedInUser() && !bYear) {
      setLoggedin(true);
      setGender(
        userData?.gender === "MALE"
          ? 0
          : userData?.gender === "FEMALE"
          ? 1
          : userData?.gender === "OTHER"
          ? 2
          : null
      );
    }
  }, []);
  React.useEffect(() => {
    getI18nData();
  }, [isWhitelisted]);

  let year = new Date().getFullYear();

  const checkinput = () => {
    if (amount < 1800) {
      notifier.error(t("notifier.error.toast6"));
      return;
    } else {
      updateProfile();
    }
  };
  const getI18nData = async (token) => {
    try {
      // const lng = cookieStorage.getCookie("language");
      const response = await ApiService.LANGUAGE(
        `language=${lang ? lang : "en"}&class=web`
      );
      const { availableLanguages, languageObject, selectedLanguage, token } =
        response.result;
      if (token) cookieStorage.createCookie("Authorization", token, 1);

      if (!lang) {
        setLanguageData({
          language: selectedLanguage,
          languageObject: languageObject,
          availableLanguages: availableLanguages,
        });
        dispatch(
          setLanguage({
            language: "en",
            languageObject: languageObject,
            availableLanguages: availableLanguages,
          })
        );
      } else
        dispatch(
          setLanguage({
            language: lang,
            languageObject: languageObject,
            availableLanguages: availableLanguages,
          })
        );

      cookieStorage.createCookie("language", selectedLanguage);
    } catch (error) {}
  };
  const handleSelect = (lng) => {
    setLang(lng.code);
  };
  return (
    <Box
      className={!loggedin ? "__signup_container" : "__signup_container_gender"}
    >
      <Box style={{ position: "relative", height: "100vh" }}>
        <img style={{ width: "100%", height: "100%", objectFit: "cover" }} src={Images.bg} />
        {!loggedin ? (
          <Box className="__bottom_bg_box">
            <Typography
              className="login_text_sm"
              style={{
                color: "#fff",
                fontSize: "20px",
                fontWeight: "600",
                textAlign: "left",
                marginLeft: "10px",
              }}
            >
              Log in
            </Typography>
            {/* <Typography
                className="login_text"
                style={{
                  marginBottom: "18px",
                  color: "#fff",
                  fontSize: "22px",
                  fontWeight: "600",
                  textAlign: "left",
                }}
              >
                Log in
              </Typography> */}
            {/* <img style={{ width: "105%" }} src={Images.siki_bg} /> */}
            <Box
              className="__bottom_box"
              style={{ background: "transparent" }}
            ></Box>
          </Box>
        ) : (
          <Box className="__bottom_bg_box_loggedIn">
            {/* <Typography
                className="login_text"
                style={{
                  marginBottom: "18px",
                  color: "#fff",
                  fontSize: "22px",
                  fontWeight: "600",
                  textAlign: "left",
                }}
              >
                Log in
              </Typography> */}
            {/* <img style={{ width: "105%" }} src={Images.siki_bg} /> */}
            <Box className="__bottom_box"></Box>
          </Box>
        )}
      </Box>
      {!loggedin ? (
        <Box className="__signup">




          {/* <Box className="__signup_image">
          <img src={Images.headPhone} alt="headphone" />
        </Box> */}
          {/* <img
            src={Images.signin_bg}
            alt="SignIn"
            height="100%"
            width="100%"
            style={{ objectFit: "cover" }}
          /> */}

          <Box>
            {/* <Box className="___signup_header">
              <p className="___title">SIKI</p>
              <Box className="___signup_moto">
                <p className="fs-14">{t("signUp.text1")}</p>
                <p className="___seperator"></p>
                <p className="fs-14">{t("signUp.text2")}</p>
              </Box>
              <Box className="__hero_title">
                <p className="text-primary">
                  {t("signUp.text3")}{" "}
                  <span className="text-sceonday">{t("signUp.text4")}</span>
                </p>
              </Box>
            </Box> */}
            <Box className="__signup_action">

            <Box className="image_container">
            <img
              src={fullbot}
              alt="logo Icon"
              className="bot_icon" // Add a class name for the first image
            />
          </Box>
              <Typography
                className="login_text"
                style={{
                  marginBottom: "18px",
                  color: "#fff",
                  fontSize: "22px",
                  fontWeight: "600",
                  textAlign: "center",
                }}
              >
                Log in
              </Typography>
              <div
                className="gradient_box"
                style={{ mt: "10px", marginBottom: "15px", position: 'relative' }}
              >
                <Box
                  id="_google_login"
                  className="__action _cp"
                  style={{ position: 'relative', zIndex: 1 }}
                >
                  <img
                    src={Images.google}
                    style={{ marginRight: "auto" }}
                    className="_cp"
                  />
                  <Typography
                    style={{ marginRight: "auto" }}
                    variant="body2"
                    color="textPrimary"
                    className="_cp"
                  >
                    {t("signUp.button1")}
                  </Typography>
                  <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', opacity: 0 }}>
                    <GoogleLogin
                      onSuccess={handleGoogleSuccess}
                      onError={() => {
                        console.error('Google login failed');
                        notifier.error('Google login failed');
                      }}
                      width="400"
                    />
                  </div>
                </Box>
              </div>

              {/* apple login */}
              <div className="gradient_box" style={{ mt: "10px" }}>
                <Box
                  className="__action _cp"
                  style={{ mt: "10px" }}
                  onClick={appleLogin}
                >
                  <img
                    src={Images.apple_icon}
                    alt="apple"
                    style={{ marginRight: "auto", width: "20px" }}
                    className="_cp"
                  />
                  <Typography
                    style={{ marginRight: "auto" }}
                    variant="body2"
                    color="textPrimary"
                    className="_cp"
                  >
                    {t("signUp.button2")}
                  </Typography>
                </Box>
              </div>
              <div style={{ marginTop: "15px" }}>
                <Typography className="siki_logo">SIKI</Typography>
              </div>
            </Box>
          </Box>
        </Box>
      ) : (
        // <div/>
        <Box className="__signup_gender" sx={{ height: "fit-content" }}>
          <Box className="__signup_image">
            <img src={Images.headPhone} alt="headphone" />
          </Box>
          <Box className="___gender">
            <Box className="__gender_">
              <img src={Images.gender} alt="gender" />
            </Box>
            <Box className="__gender_container">
              <Stack direction="column" spacing={1.5} alignItems="center">
                <Typography className="fs-14 text-center">
                  {t("signUp.label1")}
                </Typography>
                <Stack
                  direction="row"
                  onClick={() => setGender(gender === 0 ? null : 0)}
                  className={
                    "__select_gender" + (gender === 0 ? " __gender_active" : "")
                  }
                >
                  <Stack direction="row" justifyContent="center" gap="10px">
                    <img
                      src={gender === 0 ? Images.male_toggle : Images.male}
                      alt="male"
                    />
                    <Typography className="__gender_name">
                      {t("signUp.placeholder1")}
                    </Typography>
                  </Stack>
                  <DoneIcon className="__done_icon" />
                </Stack>
                <Stack
                  direction="row"
                  onClick={() => setGender(gender === 1 ? null : 1)}
                  className={
                    "__select_gender" + (gender === 1 ? " __gender_active" : "")
                  }
                >
                  <Stack direction="row" justifyContent="center" gap="10px">
                    <img
                      src={gender === 1 ? Images.female_toggle : Images.female}
                      alt="male"
                    />
                    <Typography className="__gender_name">
                      {t("signUp.placeholder2")}
                    </Typography>
                  </Stack>
                  <DoneIcon className="__done_icon" />
                </Stack>
                <Stack
                  direction="row"
                  onClick={() => setGender(gender === 2 ? null : 2)}
                  className={
                    "__select_gender" + (gender === 2 ? " __gender_active" : "")
                  }
                >
                  <Stack direction="row" justifyContent="center" gap="10px">
                    <img
                      src={gender === 2 ? Images.other_toggle : Images.other}
                      alt="male"
                    />
                    <Typography className="__gender_name">
                      {t("signUp.placeholder3")}
                    </Typography>
                  </Stack>
                  <DoneIcon className="__done_icon" />
                </Stack>
                <Stack sx={{ width: "229px" }}>
                  <Typography className="fs-14 text-center">
                    Select Language
                  </Typography>
                  {languageData && Object.keys(languageData).length > 0 ? (
                    <DropDown
                      title="Select"
                      values={languageData?.availableLanguages}
                      onChange={(lng) => handleSelect(lng)}
                    />
                  ) : null}
                </Stack>

                <p className="text">{t("signUp.text5")}</p>
                <Typography className="fs-14 text-center">
                  {t("signUp.label2")}
                </Typography>
                <Formik
                  innerRef={formRef}
                  validationSchema={schema}
                  onSubmit={(values) => {
                    updateProfile(values);
                  }}
                  initialValues={{
                    birthYear: userDetail?.birthYear || "",
                  }}
                >
                  {({ handleSubmit, values, setFieldValue }) => (
                    <Stack
                      // onClick={() => setAge(age === 0 ? null : 0)}
                      onSubmit={handleSubmit}
                    >
                      <input
                        type="number"
                        id="fname"
                        placeholder={t("signUp.placeholder4")}
                        className="__select_gender "
                        value={values.birthYear}
                        onChange={(e) => {
                          if (e.target.value > year) {
                            notifier.error(t("notifier.error.toast6"));
                          } else {
                            setAmount(e.target.value);
                            setFieldValue("birthYear", e.target.value);
                          }
                        }}
                        onKeyDown={(e) =>
                          ["e", "E", "+", "-"].includes(e.key) &&
                          e.preventDefault()
                        }
                      />
                    </Stack>
                  )}
                </Formik>

                <Stack direction="row" gap="5px" alignItems="center">
                  <Checkbox
                    checked={checked}
                    onChange={() => setChecked(!checked)}
                    {...label}
                  />
                  <Typography className="fs-14">
                    {t("signUp.text6")}{" "}
                    <span
                      className="_cp link"
                      onClick={() => history.push("/PrivacyPolicy")}
                    >
                      {t("signUp.text7")}
                    </span>{" "}
                    {t("signUp.text8")}{" "}
                    <span
                      className="_cp link"
                      onClick={() => history.push("/TermsAndCondition")}
                    >
                      {t("signUp.text9")}
                    </span>
                  </Typography>
                </Stack>
                <Button
                  disabled={
                    gender === null ||
                    !checked ||
                    // age === null ||
                    !amount ||
                    amount < 1800 ||
                    amount > new Date().getFullYear()
                  }
                  onClick={() => {
                    checkinput();
                  }}
                  sx={{
                    marginTop: "100px",
                    marginBottom: "20px !important",
                    width: "100%",
                  }}
                  variant="contained"
                  color="primary"
                >
                  {t("signUp.button3")}
                </Button>

                {/* Logout button for existing users */}
                <Button
                  onClick={logoutAndReturnToLogin}
                  sx={{
                    marginBottom: "40px !important",
                    width: "100%",
                    backgroundColor: "transparent",
                    color: "#888",
                    textTransform: "none",
                    fontSize: "14px",
                    "&:hover": {
                      backgroundColor: "transparent",
                      color: "#fff",
                    }
                  }}
                  variant="text"
                >
                  Back to login
                </Button>
              </Stack>
            </Box>
          </Box>
        </Box>
      )}
      {loading ? <Loader /> : null}
    </Box>
  );
}
